/* ==========================================================================
   pdp-zoom.js — HEYBABE Atelier · ürün sayfası galeri zoom motoru

   1) Lightbox (mobil + masaüstü): tek jest motoru (Pointer Events).
      - pinch (parmakların ortasından), pan, çift dokunma / tıklama zoom,
        tekerlek zoom, yatay kaydırma ile fotoğraf geçişi, aşağı çekip kapatma.
      - Zoom > 1 iken fotoğraf geçişi kilitlidir; sınırda lastik direnci vardır.
      - Hareket sırasında CSS geçişi yoktur; yalnızca bırakınca "oturma" geçişi.
      - touch-action: none (CSS) + gesturestart engeli: tarayıcının sayfa zoom'u
        ile çakışma olmaz.
   2) Masaüstü hover lens: imleci takip eden zoom (kaynak çözünürlüğü ile sınırlı).

   Bağımlılık yok. window.HB.PDPZoom.{init,destroy,reset}
   ========================================================================== */
(function () {
  'use strict';

  var HB = (window.HB = window.HB || {});
  if (HB.PDPZoom) return;

  var MAX_SCALE = 3.5;
  var DOUBLE_TAP_SCALE = 2.2;
  var HOVER_MAX_SCALE = 2;
  var HOVER_MIN_SCALE = 1.2;
  var MOVE_SLOP = 6;
  var TAP_MS = 300;
  var SETTLE_MS = 300;

  var instances = new WeakMap();

  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function rubber(v, max) {
    var over = Math.abs(v) - max;
    if (over <= 0) return v;
    var eased = Math.min(70, over * 0.35);
    return (v < 0 ? -1 : 1) * (max + eased);
  }

  /* ------------------------------------------------------------------------
     Lightbox
     ------------------------------------------------------------------------ */
  function Lightbox(root, opts) {
    this.root = root;
    this.opts = opts || {};
    this.viewport = root.querySelector('[data-hb-lightbox-viewport]');
    this.track = root.querySelector('[data-hb-lightbox-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hb-lightbox-slide]'));
    this.targets = this.slides.map(function (s) { return s.querySelector('[data-hb-zoom-target]'); });
    this.imgs = this.slides.map(function (s) { return s.querySelector('img'); });
    this.counter = root.querySelector('[data-hb-lightbox-counter]');
    this.closeBtn = root.querySelector('[data-hb-lightbox-close]');
    this.prevBtn = root.querySelector('[data-hb-lightbox-prev]');
    this.nextBtn = root.querySelector('[data-hb-lightbox-next]');
    this.count = this.slides.length;

    this.isOpen = false;
    this.index = 0;
    this.scale = 1;
    this.tx = 0;
    this.ty = 0;
    this.dragX = 0;
    this.W = 0;
    this.H = 0;
    this.baseW = 0;
    this.baseH = 0;

    this.pointers = new Map();
    this.mode = 'idle';
    this.gesture = null;
    this.lastTap = { t: 0, x: 0, y: 0 };
    this.samples = [];
    this.settleTimer = null;
    this.opener = null;
    this.unbinders = [];

    this._bind();
  }

  Lightbox.prototype._on = function (el, type, fn, options) {
    if (!el) return;
    el.addEventListener(type, fn, options);
    this.unbinders.push(function () { el.removeEventListener(type, fn, options); });
  };

  Lightbox.prototype._bind = function () {
    var self = this;
    var vp = this.viewport;
    if (!vp) return;

    this._on(vp, 'pointerdown', function (e) { self._down(e); });
    this._on(vp, 'pointermove', function (e) { self._move(e); });
    this._on(vp, 'pointerup', function (e) { self._up(e, false); });
    this._on(vp, 'pointercancel', function (e) { self._up(e, true); });
    this._on(vp, 'lostpointercapture', function (e) {
      if (self.pointers.has(e.pointerId)) self._up(e, true);
    });
    this._on(vp, 'wheel', function (e) { self._wheel(e); }, { passive: false });
    this._on(vp, 'contextmenu', function (e) { if (self.scale > 1) e.preventDefault(); });
    this._on(vp, 'dragstart', function (e) { e.preventDefault(); });

    /* iOS Safari: sistemin kendi sayfa zoom jesti. */
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (name) {
      self._on(self.root, name, function (e) { e.preventDefault(); }, { passive: false });
    });

    this._on(this.closeBtn, 'click', function () { self.close(); });
    this._on(this.prevBtn, 'click', function () { self.goTo(self.index - 1); });
    this._on(this.nextBtn, 'click', function () { self.goTo(self.index + 1); });
    this._on(this.root, 'keydown', function (e) { self._key(e); });
    this._on(window, 'resize', function () { if (self.isOpen) self._relayout(); });
    this._on(window, 'orientationchange', function () { if (self.isOpen) setTimeout(function () { self._relayout(); }, 220); });

    this.imgs.forEach(function (img, i) {
      if (!img) return;
      self._on(img, 'load', function () { if (i === self.index && self.isOpen) self._measureBase(); });
    });
  };

  Lightbox.prototype.destroy = function () {
    this.unbinders.forEach(function (fn) { fn(); });
    this.unbinders = [];
    if (this.isOpen) this.close(true);
  };

  /* --- yerleşim ---------------------------------------------------------- */
  Lightbox.prototype._measureView = function () {
    this.W = this.viewport.clientWidth || window.innerWidth;
    this.H = this.viewport.clientHeight || window.innerHeight;
  };

  Lightbox.prototype._measureBase = function () {
    var img = this.imgs[this.index];
    this.baseW = (img && img.offsetWidth) || this.W * 0.95;
    this.baseH = (img && img.offsetHeight) || this.H * 0.88;
  };

  Lightbox.prototype._relayout = function () {
    this._measureView();
    this._resetZoomState();
    this._measureBase();
    this._applyTrack(false);
    this._applyZoom(false);
  };

  Lightbox.prototype._limits = function (s) {
    return {
      x: Math.max(0, (this.baseW * s - this.W) / 2),
      y: Math.max(0, (this.baseH * s - this.H) / 2)
    };
  };

  /* --- uygulama ---------------------------------------------------------- */
  Lightbox.prototype._settle = function (on) {
    var root = this.root;
    clearTimeout(this.settleTimer);
    if (on && !prefersReduced()) {
      root.classList.add('is-settling');
      this.settleTimer = setTimeout(function () { root.classList.remove('is-settling'); }, SETTLE_MS + 40);
    } else {
      root.classList.remove('is-settling');
    }
  };

  Lightbox.prototype._applyTrack = function (animate) {
    this._settle(animate);
    var x = -this.index * this.W + this.dragX;
    this.track.style.transform = 'translate3d(' + x + 'px,0,0)';
  };

  Lightbox.prototype._applyZoom = function (animate) {
    this._settle(animate);
    var t = this.targets[this.index];
    if (!t) return;
    t.style.transform = this.scale === 1 && this.tx === 0 && this.ty === 0
      ? ''
      : 'translate3d(' + this.tx + 'px,' + this.ty + 'px,0) scale(' + this.scale + ')';
    this.root.classList.toggle('is-zoomed', this.scale > 1.01);
  };

  Lightbox.prototype._resetZoomState = function () {
    this.scale = 1;
    this.tx = 0;
    this.ty = 0;
    this.dragX = 0;
    this.root.classList.remove('is-zoomed');
    this.targets.forEach(function (t) { if (t) t.style.transform = ''; });
  };

  Lightbox.prototype._clampPan = function () {
    var lim = this._limits(this.scale);
    this.tx = clamp(this.tx, -lim.x, lim.x);
    this.ty = clamp(this.ty, -lim.y, lim.y);
  };

  Lightbox.prototype._updateChrome = function () {
    if (this.counter) this.counter.textContent = pad2(this.index + 1) + ' / ' + pad2(this.count);
    if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= this.count - 1;
  };

  Lightbox.prototype._load = function (i) {
    for (var k = i - 1; k <= i + 1; k++) {
      var img = this.imgs[k];
      if (img && !img.getAttribute('src') && img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    }
  };

  /* --- açma / kapama ------------------------------------------------------ */
  Lightbox.prototype.open = function (index, opener) {
    if (this.isOpen || !this.count) return;
    this.isOpen = true;
    this.opener = opener || document.activeElement;
    this.root.hidden = false;
    this.previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.index = clamp(index || 0, 0, this.count - 1);
    this._measureView();
    this._resetZoomState();
    this._load(this.index);
    this._measureBase();
    this._applyTrack(false);
    this._updateChrome();
    if (this.closeBtn) this.closeBtn.focus({ preventScroll: true });
  };

  Lightbox.prototype.close = function (silent) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.pointers.clear();
    this.mode = 'idle';
    this._settle(false);
    this.viewport.style.transform = '';
    this.viewport.style.opacity = '';
    this.root.hidden = true;
    document.body.style.overflow = this.previousOverflow || '';
    this._resetZoomState();
    var idx = this.index;
    if (!silent && this.opts.onClose) this.opts.onClose(idx);
    if (this.opener && this.opener.focus) {
      try { this.opener.focus({ preventScroll: true }); } catch (err) { /* sessiz */ }
    }
    this.opener = null;
  };

  Lightbox.prototype.goTo = function (i, instant) {
    i = clamp(i, 0, this.count - 1);
    if (i !== this.index) {
      this._resetZoomState();
      this.index = i;
      this._load(i);
      this._measureBase();
    }
    this.dragX = 0;
    this._applyTrack(!instant);
    this._updateChrome();
  };

  /* --- klavye ------------------------------------------------------------- */
  Lightbox.prototype._key = function (e) {
    if (!this.isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); if (this.scale <= 1.01) this.goTo(this.index - 1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); if (this.scale <= 1.01) this.goTo(this.index + 1); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); this._zoomAt(this.W / 2 + this._left(), this.H / 2 + this._top(), Math.min(MAX_SCALE, this.scale * 1.4), true); return; }
    if (e.key === '-') { e.preventDefault(); this._zoomAt(this.W / 2 + this._left(), this.H / 2 + this._top(), Math.max(1, this.scale / 1.4), true); return; }
    if (e.key === 'Tab') {
      var items = [this.closeBtn, this.prevBtn, this.nextBtn].filter(function (b) {
        return b && !b.disabled && b.offsetParent !== null;
      });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || !this.root.contains(active))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (active === last || !this.root.contains(active))) { e.preventDefault(); first.focus(); }
    }
  };

  /* --- yardımcılar -------------------------------------------------------- */
  Lightbox.prototype._left = function () { return this.viewport.getBoundingClientRect().left; };
  Lightbox.prototype._top = function () { return this.viewport.getBoundingClientRect().top; };

  /* (clientX, clientY) noktasını sabit tutarak ölçeği s yap */
  Lightbox.prototype._zoomAt = function (cx, cy, s, animate) {
    var px = cx - (this._left() + this.W / 2);
    var py = cy - (this._top() + this.H / 2);
    var ratio = s / this.scale;
    this.tx = px - (px - this.tx) * ratio;
    this.ty = py - (py - this.ty) * ratio;
    this.scale = s;
    if (s <= 1.01) { this.scale = 1; this.tx = 0; this.ty = 0; }
    this._clampPan();
    this._applyZoom(animate);
  };

  /* --- işaretçiler -------------------------------------------------------- */
  Lightbox.prototype._pt = function (e) {
    return { x: e.clientX, y: e.clientY, type: e.pointerType };
  };

  Lightbox.prototype._down = function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { this.viewport.setPointerCapture(e.pointerId); } catch (err) { /* sessiz */ }
    this._settle(false);
    this.pointers.set(e.pointerId, this._pt(e));
    this.samples = [{ x: e.clientX, y: e.clientY, t: performance.now() }];

    if (this.pointers.size === 2) {
      this._beginPinch();
    } else if (this.pointers.size === 1) {
      this.mode = 'pending';
      this.gesture = {
        id: e.pointerId, x0: e.clientX, y0: e.clientY, t0: performance.now(),
        tx0: this.tx, ty0: this.ty, moved: false
      };
    }
  };

  Lightbox.prototype._beginPinch = function () {
    var pts = Array.from(this.pointers.values());
    var dx = pts[1].x - pts[0].x;
    var dy = pts[1].y - pts[0].y;
    var cx = (pts[0].x + pts[1].x) / 2;
    var cy = (pts[0].y + pts[1].y) / 2;
    /* Yatay sürükleme / aşağı çekme yarım kaldıysa temizle. */
    this.dragX = 0;
    this._applyTrack(false);
    this.viewport.style.transform = '';
    this.viewport.style.opacity = '';
    this.mode = 'pinch';
    this.gesture = {
      d0: Math.max(1, Math.hypot(dx, dy)),
      s0: this.scale,
      tx0: this.tx, ty0: this.ty,
      px0: cx - (this._left() + this.W / 2),
      py0: cy - (this._top() + this.H / 2)
    };
  };

  Lightbox.prototype._move = function (e) {
    var p = this.pointers.get(e.pointerId);
    if (!p) return;
    p.x = e.clientX;
    p.y = e.clientY;
    var now = performance.now();
    this.samples.push({ x: e.clientX, y: e.clientY, t: now });
    if (this.samples.length > 6) this.samples.shift();

    var g = this.gesture;
    if (!g) return;

    if (this.mode === 'pinch' && this.pointers.size >= 2) {
      var pts = Array.from(this.pointers.values());
      var dist = Math.max(1, Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y));
      var cx = (pts[0].x + pts[1].x) / 2 - (this._left() + this.W / 2);
      var cy = (pts[0].y + pts[1].y) / 2 - (this._top() + this.H / 2);
      var s = clamp(g.s0 * dist / g.d0, 1, MAX_SCALE * 1.15);
      /* Başlangıçtaki içerik noktası parmakların ortasında kalsın. */
      var r = s / g.s0;
      this.scale = s;
      this.tx = cx - (g.px0 - g.tx0) * r;
      this.ty = cy - (g.py0 - g.ty0) * r;
      var lim = this._limits(s);
      this.tx = rubber(this.tx, lim.x);
      this.ty = rubber(this.ty, lim.y);
      this._applyZoom(false);
      return;
    }

    if (this.mode === 'pending') {
      var dx0 = e.clientX - g.x0;
      var dy0 = e.clientY - g.y0;
      if (Math.hypot(dx0, dy0) < MOVE_SLOP) return;
      g.moved = true;
      if (this.scale > 1.01) this.mode = 'pan';
      else this.mode = Math.abs(dx0) > Math.abs(dy0) ? 'swipe' : 'dismiss';
    }

    if (this.mode === 'pan') {
      var lim2 = this._limits(this.scale);
      this.tx = rubber(g.tx0 + (e.clientX - g.x0), lim2.x);
      this.ty = rubber(g.ty0 + (e.clientY - g.y0), lim2.y);
      this._applyZoom(false);
    } else if (this.mode === 'swipe') {
      var dx = e.clientX - g.x0;
      var atStart = this.index === 0 && dx > 0;
      var atEnd = this.index === this.count - 1 && dx < 0;
      this.dragX = (atStart || atEnd) ? dx * 0.3 : dx;
      this._applyTrack(false);
    } else if (this.mode === 'dismiss') {
      var dy = e.clientY - g.y0;
      var fade = clamp(1 - Math.abs(dy) / (this.H * 0.8), 0.25, 1);
      this.viewport.style.transform = 'translate3d(0,' + dy + 'px,0)';
      this.viewport.style.opacity = String(fade);
    }
  };

  Lightbox.prototype._velocity = function () {
    var s = this.samples;
    if (s.length < 2) return { vx: 0, vy: 0 };
    var a = s[0];
    var b = s[s.length - 1];
    var dt = Math.max(1, b.t - a.t);
    return { vx: (b.x - a.x) / dt, vy: (b.y - a.y) / dt };
  };

  Lightbox.prototype._up = function (e, cancelled) {
    if (!this.pointers.has(e.pointerId)) return;
    this.pointers.delete(e.pointerId);
    try { this.viewport.releasePointerCapture(e.pointerId); } catch (err) { /* sessiz */ }
    var g = this.gesture;
    var wasMode = this.mode;

    if (wasMode === 'pinch') {
      if (this.pointers.size >= 2) {
        /* 3+ parmak: kalan iki parmakla pinch'i yeniden başlat. */
        this._beginPinch();
        return;
      }
      if (this.pointers.size === 1) {
        /* Bir parmak kaldı: kalan parmakla pan'e devam. */
        var rest = Array.from(this.pointers.entries())[0];
        this.mode = 'pan';
        this.gesture = {
          id: rest[0], x0: rest[1].x, y0: rest[1].y, t0: performance.now(),
          tx0: this.tx, ty0: this.ty, moved: true
        };
        this.samples = [{ x: rest[1].x, y: rest[1].y, t: performance.now() }];
        return;
      }
      this._finishZoom();
      return;
    }

    if (this.pointers.size > 0) return;

    var v = this._velocity();
    this.mode = 'idle';
    this.gesture = null;

    if (wasMode === 'pan') {
      this._finishZoom();
    } else if (wasMode === 'swipe') {
      var threshold = this.W * 0.2;
      var go = 0;
      if (!cancelled) {
        if (Math.abs(this.dragX) > threshold) go = this.dragX < 0 ? 1 : -1;
        else if (Math.abs(v.vx) > 0.5 && Math.abs(this.dragX) > 20) go = v.vx < 0 ? 1 : -1;
      }
      this.dragX = 0;
      this.goTo(this.index + go);
    } else if (wasMode === 'dismiss') {
      var dy = e.clientY - (g ? g.y0 : e.clientY);
      var shouldClose = !cancelled && (Math.abs(dy) > this.H * 0.18 || Math.abs(v.vy) > 0.6);
      if (shouldClose) {
        this.close();
      } else {
        this._settle(true);
        this.viewport.style.transform = '';
        this.viewport.style.opacity = '';
      }
    } else if (wasMode === 'pending' && !cancelled) {
      this._tap(e);
    }
  };

  /* Pinch / pan sonrası: sınıra oturt, 1'e yakınsa tam 1x. */
  Lightbox.prototype._finishZoom = function () {
    this.mode = 'idle';
    this.gesture = null;
    if (this.scale < 1.03) {
      this.scale = 1; this.tx = 0; this.ty = 0;
    } else {
      this.scale = Math.min(this.scale, MAX_SCALE);
      this._clampPan();
    }
    this._applyZoom(true);
  };

  Lightbox.prototype._tap = function (e) {
    var now = performance.now();
    var isMouse = e.pointerType === 'mouse' || e.pointerType === 'pen';
    var lt = this.lastTap;
    var isDouble = !isMouse && (now - lt.t) < TAP_MS && Math.hypot(e.clientX - lt.x, e.clientY - lt.y) < 40;
    if (isMouse || isDouble) {
      this.lastTap = { t: 0, x: 0, y: 0 };
      var target = this.scale > 1.05 ? 1 : Math.min(DOUBLE_TAP_SCALE, MAX_SCALE);
      this._zoomAt(e.clientX, e.clientY, target, true);
    } else {
      this.lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  };

  Lightbox.prototype._wheel = function (e) {
    if (!this.isOpen) return;
    e.preventDefault();
    var k = e.ctrlKey ? 0.01 : 0.0018;
    var s = clamp(this.scale * Math.exp(-e.deltaY * k), 1, MAX_SCALE);
    if (s === this.scale) return;
    this._zoomAt(e.clientX, e.clientY, s, false);
  };

  /* ------------------------------------------------------------------------
     Masaüstü hover lens
     ------------------------------------------------------------------------ */
  function Stage(section, opts) {
    this.section = section;
    this.opts = opts || {};
    this.stage = section.querySelector('[data-hb-stage]');
    this.col = section.querySelector('[data-hb-desktop-gallery]');
    this.unbinders = [];
    this.img = null;
    this.slide = null;
    this.zoomMax = 0;
    this.cur = { s: 1, x: 0, y: 0 };
    this.target = { s: 1, x: 0, y: 0 };
    this.raf = 0;
    this.last = 0;
    this.hovering = false;
    this.downAt = null;
    if (this.stage) this._bind();
  }

  Stage.prototype._on = Lightbox.prototype._on;

  Stage.prototype._canHover = function () {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  };

  Stage.prototype._active = function () {
    return this.stage.querySelector('.hb-pdp__stage-slide.is-active');
  };

  Stage.prototype._bind = function () {
    var self = this;
    var st = this.stage;
    this._on(st, 'pointermove', function (e) { self._move(e); });
    this._on(st, 'pointerleave', function (e) { if (e.pointerType !== 'touch') self._leave(); });
    this._on(st, 'pointerdown', function (e) { self.downAt = { x: e.clientX, y: e.clientY, type: e.pointerType }; });
    this._on(st, 'click', function (e) {
      if (e.target.closest('.hb-pdp__stage-counter')) return;
      var d = self.downAt;
      if (d && Math.hypot(e.clientX - d.x, e.clientY - d.y) > 8) return;
      self._open(st);
    });
    this._on(st, 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self._open(st); }
    });
    if (this.col) {
      this._on(this.col, 'keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var t = e.target;
        if (!(t === st || (t.closest && t.closest('[data-hb-thumb]')))) return;
        if (!self.opts.getIndex || !self.opts.setIndex) return;
        var n = self.opts.count || 0;
        var i = self.opts.getIndex() + (e.key === 'ArrowRight' ? 1 : -1);
        if (i < 0 || i >= n) return;
        e.preventDefault();
        self._reset(true);
        self.opts.setIndex(i);
      });
    }
  };

  Stage.prototype._open = function (opener) {
    this._reset(true);
    if (this.opts.open) this.opts.open(this.opts.getIndex ? this.opts.getIndex() : 0, opener);
  };

  Stage.prototype._begin = function (slide) {
    var img = slide && slide.querySelector('.hb-pdp__stage-img');
    this.slide = slide;
    this.img = img || null;
    this.zoomMax = 0;
    if (!img || !img.complete || !img.naturalWidth) return;
    var ow = img.offsetWidth;
    var oh = img.offsetHeight;
    if (!ow || !oh) return;
    var z = Math.min(HOVER_MAX_SCALE, img.naturalWidth / ow, img.naturalHeight / oh);
    this.zoomMax = z >= HOVER_MIN_SCALE ? z : 0;
    this.ow = ow;
    this.oh = oh;
  };

  Stage.prototype._move = function (e) {
    if (e.pointerType === 'touch') return;
    if (!this._canHover()) return;
    var slide = this._active();
    if (!slide) return;
    if (slide !== this.slide) {
      this._reset(true);
      this._begin(slide);
    } else if (!this.hovering) {
      this._begin(slide);
    }
    if (!this.img || !this.zoomMax) return;

    this.hovering = true;
    var r = this.slide.getBoundingClientRect();
    var px = clamp(e.clientX - (r.left + r.width / 2), -this.ow / 2, this.ow / 2);
    var py = clamp(e.clientY - (r.top + r.height / 2), -this.oh / 2, this.oh / 2);
    var s = this.zoomMax;
    /* İmlecin altındaki nokta yerinde kalır; kenara varınca görsel kenarı hizalanır. */
    this.target = { s: s, x: -(s - 1) * px, y: -(s - 1) * py };
    this.stage.classList.add('is-zooming');
    this.img.style.willChange = 'transform';
    this._tick();
  };

  Stage.prototype._leave = function () {
    this.hovering = false;
    this.target = { s: 1, x: 0, y: 0 };
    this._tick();
  };

  Stage.prototype._tick = function () {
    if (this.raf) return;
    var self = this;
    this.last = performance.now();
    var step = function (now) {
      self.raf = 0;
      var img = self.img;
      if (!img) return;
      var dt = Math.min(48, now - self.last);
      self.last = now;
      var k = prefersReduced() ? 1 : 1 - Math.pow(1 - 0.16, dt / 16.67);
      var c = self.cur;
      var t = self.target;
      c.s += (t.s - c.s) * k;
      c.x += (t.x - c.x) * k;
      c.y += (t.y - c.y) * k;
      var settled = Math.abs(t.s - c.s) < 0.002 && Math.abs(t.x - c.x) < 0.3 && Math.abs(t.y - c.y) < 0.3;
      if (settled) { c.s = t.s; c.x = t.x; c.y = t.y; }
      img.style.transform = (c.s === 1 && c.x === 0 && c.y === 0)
        ? ''
        : 'translate3d(' + c.x + 'px,' + c.y + 'px,0) scale(' + c.s + ')';
      if (!settled) {
        self.raf = requestAnimationFrame(step);
      } else if (!self.hovering) {
        img.style.willChange = '';
        self.stage.classList.remove('is-zooming');
      }
    };
    this.raf = requestAnimationFrame(step);
  };

  Stage.prototype._reset = function (instant) {
    cancelAnimationFrame(this.raf);
    this.raf = 0;
    this.hovering = false;
    this.cur = { s: 1, x: 0, y: 0 };
    this.target = { s: 1, x: 0, y: 0 };
    if (this.img) {
      this.img.style.transform = '';
      this.img.style.willChange = '';
    }
    if (this.stage) this.stage.classList.remove('is-zooming');
    this.slide = null;
    this.img = null;
    this.zoomMax = 0;
    return instant;
  };

  Stage.prototype.destroy = function () {
    this._reset(true);
    this.unbinders.forEach(function (fn) { fn(); });
    this.unbinders = [];
  };

  /* ------------------------------------------------------------------------
     Bölüm düzeyinde birleştirme
     ------------------------------------------------------------------------ */
  function init(section, opts) {
    if (!section || instances.has(section)) return instances.get(section) || null;
    opts = opts || {};
    var root = section.querySelector('[data-hb-lightbox]');
    var inst = { lightbox: null, stage: null, unbinders: [] };

    if (root) {
      inst.lightbox = new Lightbox(root, { onClose: opts.onClose });

      /* Mobil galeri: fotoğrafa dokununca tam ekran. */
      var slides = Array.prototype.slice.call(section.querySelectorAll('.hb-pdp__gallery-slide'));
      slides.forEach(function (slide, idx) {
        var fn = function (e) {
          if (e.target.closest && e.target.closest('button, a')) return;
          inst.lightbox.open(idx, slide);
        };
        slide.addEventListener('click', fn);
        inst.unbinders.push(function () { slide.removeEventListener('click', fn); });
      });
    }

    inst.stage = new Stage(section, {
      count: opts.count,
      getIndex: opts.getDesktopIndex,
      setIndex: opts.setDesktopIndex,
      open: function (idx, opener) { if (inst.lightbox) inst.lightbox.open(idx, opener); }
    });

    instances.set(section, inst);
    return inst;
  }

  function destroy(section) {
    var inst = instances.get(section);
    if (!inst) return;
    if (inst.lightbox) inst.lightbox.destroy();
    if (inst.stage) inst.stage.destroy();
    inst.unbinders.forEach(function (fn) { fn(); });
    instances.delete(section);
  }

  function reset(section) {
    var inst = instances.get(section);
    if (!inst) return;
    if (inst.stage) inst.stage._reset(true);
    if (inst.lightbox && inst.lightbox.isOpen) inst.lightbox._resetZoomState();
  }

  HB.PDPZoom = { init: init, destroy: destroy, reset: reset };

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-hb-product]');
    if (el) destroy(el);
    else if (e.target && e.target.matches && e.target.matches('[data-hb-product]')) destroy(e.target);
  });
})();
